export enum SeitenlokalisationEnum {
  Links = 'L',
  Rechts = 'R',
  Beidseitig = 'B', // represents "paarig" in OPS context
}
